import client, { PUBLIC_CLIENT, PRIVATE_CLIENT } from '../../services/client';
import sessionStore from '../../store/session';

export const getContactsAction = async (business_id) => {
    const response = await client.get('contacts/', PRIVATE_CLIENT, null, {
        business_id: business_id,
    });

    sessionStore.setContacts(response.results);
};
